import { inject, Injectable } from '@angular/core';
import { AuthStore } from './auth/auth.store';
import { ELoadingEntity, IErrorProperty } from 'src/models/generic-store.model';
import { ELoginDeviceType } from 'src/models/auth.model';

@Injectable({ providedIn: 'root' })
export class AuthDataService {
  private authStore = inject(AuthStore);

  // State signals
  public tokenData = this.authStore.tokenData;
  public logoutIdToken = this.authStore.logoutIdToken;
  public refreshTokenExpires = this.authStore.refreshTokenExpires;
  public authLoadingProps = this.authStore.loadingProps;

  public authIsLoading(loadingEntity: ELoadingEntity): boolean {
    return this.authStore.isLoading(loadingEntity);
  }

  public authHasErrored(loadingEntity: ELoadingEntity): boolean {
    return this.authStore.hasErrored(loadingEntity);
  }

  public authGetError(loadingEntity: ELoadingEntity): IErrorProperty | null {
    return this.authStore.getError(loadingEntity);
  }

  public authClearError(loadingEntity: ELoadingEntity): void {
    this.authStore.clearError(loadingEntity);
  }

  // Computed signals
  public accessToken = this.authStore.accessToken;
  public showLoginLoader = this.authStore.showLoginLoader;

  public getAuthTokenData(type: ELoginDeviceType, code: string, redirectUri: string): void {
    this.authStore.getAuthTokenData({ type, code, redirectUri });
  }

  public refreshToken(type: ELoginDeviceType, refreshToken: string): void {
    this.authStore.refreshToken({ type, refreshToken });
  }

  public logoutAndGetId(accessToken: string): void {
    this.authStore.logoutAndGetId({ accessToken });
  }

  public resetAuthState(): void {
    this.authStore.resetState();
  }

  public setRefreshTokenExpires(expires: string): void {
    this.authStore.setRefreshTokenExpires(expires);
  }

  public clearRefreshTokenExpires(): void {
    this.authStore.clearRefreshTokenExpires();
  }

}